import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ComposerTabsResponse,
  FilterCriteria,
  OrderingCriteria,
  PaginatedComposerResponse
} from '../components/composer-grid/utils/composer-grid.models';

@Injectable()
export class ComposerDataService {
  constructor(private httpClient: HttpClient) {}

  getComposerTabs(rid: string): Observable<ComposerTabsResponse> {
    rid = rid.replace('#', '');
    return this.httpClient.get<ComposerTabsResponse>(
      `/api/v1/composer/route/${rid}/tabs`
    );
  }

  getComposerTabData(
    rid: string,
    tab: string,
    page = 1,
    limit = 20,
    filters?: FilterCriteria[],
    ordering?: OrderingCriteria[]
  ): Observable<PaginatedComposerResponse> {
    rid = rid.replace('#', '');
    let params = new HttpParams()
      .set('tab', tab)
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (filters?.length) {
      params = params.set('filters', JSON.stringify(filters));
    }
    if (ordering?.length) {
      params = params.set('ordering', JSON.stringify(ordering));
    }

    return this.httpClient.get<PaginatedComposerResponse>(
      `/api/v1/composer/route/${rid}`,
      { params }
    );
  }
}
